import { defineComponent } from '@vue/composition-api';
import __vue_component__ from '../content/CustomImage.vue.js';

/**
 * @deprecated Use SdsFlag instead
 */
var script = defineComponent({
    props: {
        flag: {
            type: String,
            required: true,
        },
        isLarge: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        CustomImage: __vue_component__,
    },
});

export default script;
